// removed by extract-text-webpack-plugin
module.exports = {"flying-letter-container":"FlyingLetter__flying-letter-container","flyingLetterContainer":"FlyingLetter__flying-letter-container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/FlyingLetter/FlyingLetter.mobile.scss
// module id = 1704
// module chunks = 8